import type { PluginOptions } from './type';
import { useSettingsStore } from '../stores';
import { getEmpCode } from '../utils/auth';

const options: PluginOptions = {
  onVuePluginRegister: async () => {
    const {
      settings: { ratingConfig },
    } = useSettingsStore();
    if (!ratingConfig?.show) {
      return;
    }

    const userId = getEmpCode();
    if (ratingConfig.appId && ratingConfig.appSecret && userId) {
      await import('@easy/rating-pc-sdk/style.css');
      const { default: RatingPcSdk } = await import('@easy/rating-pc-sdk');
      const { hostname } = window.location;
      const isSit = hostname.includes('.sit.');
      (window as any).ratingSdk = new RatingPcSdk({
        ...ratingConfig,
        userNo: userId,
        // @ts-ignore
        env: isSit || import.meta.env.DEV ? 'sit' : 'prd',
      });
    }
  },
};

export default options;
